import { render, staticRenderFns } from "./OutcomePlansSelection.vue?vue&type=template&id=5bcde15a&scoped=true"
import script from "./OutcomePlansSelection.vue?vue&type=script&lang=js"
export * from "./OutcomePlansSelection.vue?vue&type=script&lang=js"
import style0 from "./OutcomePlansSelection.vue?vue&type=style&index=0&id=5bcde15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcde15a",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg,QBtn});
